import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../helper/api";

export const addBankDetail = createAsyncThunk(
  "addBankDetail/addBankDetail",
  async (payload, thunkAPI) => {
    try {
     
      const response = await api.post(`bank/${payload.user_id}`, payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.response?.data?.message || "Unknown error",
      });
    }
  }
);

const addBankDetailSlice = createSlice({
  name: "addBankDetail",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addBankDetail.pending, (state) => {
        state.loading = true;
      })
      .addCase(addBankDetail.fulfilled, (state, action) => {
          
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(addBankDetail.rejected, (state, action) => {
        // 
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default addBankDetailSlice.reducer;
